<template>
  <div class="commission-manager">
    <el-form :inline="true">
      <el-form-item label="">
        <el-input
          style="width: 170px"
          v-model="queryForm.keyWord"
          placeholder="请输入姓名/手机号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          style="width: 170px"
          v-model="queryForm.isEnable"
          placeholder="是否启用"
          clearable
        >
          <el-option
            v-for="item in isEnableOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <toolbar
          :buttonList="buttonList"
          @callFunction="callFunction"
        ></toolbar>
      </el-form-item>
    </el-form>

    <!-- 大V合作配置列表 - 完全匹配截图 -->
    <el-table
      :data="tableList"
      border
      stripe
      @current-change="handleCurrentChange"
      style="width: 100%; margin-top: 20px"
      row-key="id"
      header-align="center"
    >
      <!-- 大V姓名 -->
      <el-table-column
        prop="name"
        label="大V姓名"
        width="150"
        header-align="center"
        align="center"
      />
      <!-- 手机 -->
      <el-table-column
        prop="phoneNumber"
        label="手机"
        width="150"
        header-align="center"
        align="center"
      />

      <!-- 合作有效期 -->
      <el-table-column
        prop="cooperateTime"
        label="合作有效期"
        width="280"
        header-align="center"
        align="center"
      >
        <template #default="scope">
          {{ scope.row.startTime }}至{{ scope.row.endTime }}
        </template>
      </el-table-column>
      <!-- 创建人 -->
      <el-table-column
        prop="createUserName"
        label="创建人"
        width="110"
        header-align="center"
        align="center"
      />
      <!-- 创建时间 -->
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="180"
        header-align="center"
        align="center"
      />
      <!-- 是否启用 -->
      <el-table-column
        prop="isEnable"
        label="是否启用"
        width="110"
        header-align="center"
        align="center"
      >
        <template #default="scope">
          <el-tag :type="scope.row.isEnable ? 'success' : 'info'">
            {{ scope.row.isEnable ? "已启用" : "已禁用" }}
          </el-tag>
        </template>
      </el-table-column>
      <!-- 修改人 -->
      <el-table-column
        prop="updateUserName"
        label="修改人"
        width="110"
        header-align="center"
        align="center"
      />
      <!-- 修改时间 -->
      <el-table-column
        prop="updateTime"
        label="修改时间"
        width=""
        header-align="center"
        align="center"
      />
      <!-- 操作栏 - 修改 + 记录 完全匹配截图 -->
      <!--			<el-table-column-->
      <!--					label="操作"-->
      <!--					width="160"-->
      <!--					header-align="center"-->
      <!--					align="center"-->
      <!--			>-->
      <!--				<template #default="scope">-->
      <!--					<el-button type="text" style="color:#f56c6c" @click="handleEdit(scope.row)">修改</el-button>-->
      <!--					<el-button type="text" style="color:#f56c6c" @click="handleRecord(scope.row)">记录</el-button>-->
      <!--				</template>-->
      <!--			</el-table-column>-->
    </el-table>

    <!-- 分页组件 - 匹配截图底部分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentPageChange"
      :current-page="pageInfo.pageNum"
      :page-sizes="[20, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageInfo.total"
      style="margin-top: 20px; text-align: left"
    >
    </el-pagination>

    <!-- 新增/编辑弹窗 - 适配大V合作字段 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      destroy-on-close
      :close-on-click-modal="false"
    >
      <el-form
        :model="formData"
        :rules="formRules"
        ref="formRef"
        label-width="130px"
      >
        <!--				<el-form-item label="ID" prop="id">-->
        <!--					<el-input-->
        <!--							v-model.number="formData.id"-->
        <!--							placeholder="自动生成"-->
        <!--							style="width: 60%"-->
        <!--							disabled-->
        <!--					/>-->
        <!--				</el-form-item>-->

        <el-form-item label="大V姓名" prop="starName">
          <el-input
            v-model="formData.starName"
            placeholder="请获取大V姓名"
            style="width: 80%"
          />
        </el-form-item>

        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model="formData.phone"
            placeholder="请输入手机号码"
            style="width: 80%; margin-right: 10px"
          />
          <el-button type="primary" @click="handleGetPhone"
            >点击获取信息</el-button
          >
        </el-form-item>

        <el-form-item label="" prop="wechat">
          昵称：{{ formData.nickName }} 
          <!-- 姓名：{{ formData.starName }} -->
        </el-form-item>

        <el-form-item label="合作有效期" prop="cooperateTime">
          <el-date-picker
            v-model="formData.cooperateTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 80%"
          />
        </el-form-item>

        <!--				<el-form-item label="是否启用" prop="isEnable">-->
        <!--					<el-switch-->
        <!--							v-model="formData.isEnable"-->
        <!--							active-text="已启用"-->
        <!--							inactive-text="已禁用"-->
        <!--							:active-value="true"-->
        <!--							:inactive-value="false"-->
        <!--					/>-->
        <!--				</el-form-item>-->
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
// 接口适配，替换为你实际的大V合作列表/增删改查接口
import {
  addUserDv,
  getUserByPhoneNumber,
  getUserDvPageList,
  updateStatusById,
  updateUserDv,
} from "../../api/api";
import { useEnterSearch, removeEnterSearch } from "../../../util/enterSearch";
export default {
  components: { Toolbar },
  name: "StarManager",
  data() {
    return {
      buttonList: [],
      // 表格数据
      tableList: [],
      // 分页信息 - 匹配截图20条/页
      pageInfo: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      // 弹窗
      dialogVisible: false,
      dialogTitle: "",
      formRef: null,
      // 表单数据 - 完全匹配表格字段
      formData: {
        id: undefined,
        starName: undefined,
        nickName: undefined,

        phone: undefined,
        wechat: undefined,
        cooperateTime: undefined,
        isEnable: undefined,
        createTime: undefined,
        updateTime: undefined,
        createUserName: undefined,
        updateUserName: undefined,
      },
      // 表单校验
      formRules: {
        starName: [
          { required: true, message: "请获取大 V 姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],

        cooperateTime: [
          { required: true, message: "请选择合作有效期", trigger: "change" },
        ],
      },
      // 当前选中行
      currentRow: null,
      // 查询条件
      queryForm: {
        keyWord: "",
        isEnable: ""
      },
      //号码状态
      isEnableOptions: [
        {
          value: true,
          label: "启用",
        },
        {
          value: false,
          label: "禁用",
        },
      ]
    };
  },
  beforeDestroy() {
    // 移除全局回车监听
    removeEnterSearch();
  },
  methods: {
    enable() {
      if (!this.currentRow) {
        this.$message.error("请选择要启用的数据！");
        return;
      }
      if (this.currentRow.isEnable) {
        this.$message.error("当前数据已启用，请勿重复操作！");
        return;
      }
      this.$confirm("此操作将启用该大V合作配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateStatusById({ id: this.currentRow.id, isEnable: true })
          .then((res) => {
            if (res.data.success) {
              this.$message.success("启用成功");
              this.getList();
              this.currentRow = null
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(() => {
            this.$message.error("启用接口请求失败");
          });
      });
    },
    disable() {
      if (!this.currentRow) {
        this.$message.error("请选择要禁用的数据！");
        return;
      }
      if (!this.currentRow.isEnable) {
        this.$message.error("当前数据已禁用，请勿重复操作！");
        return;
      }
      this.$confirm("此操作将禁用该大V合作配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateStatusById({ id: this.currentRow.id, isEnable: false })
          .then((res) => {
            if (res.data.success) {
              this.$message.success("禁用成功");
              this.getList();
               this.currentRow = null
            } else {
              this.$message.error(res.data.message);
            }
          })
          .catch(() => {
            this.$message.error("禁用接口请求失败");
          });
      });
    },
    handleGetPhone() {
      // 先验证手机号格式
      if (!this.formData.phone) {
        this.$message.error("请输入手机号码");
        return;
      }
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(this.formData.phone)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }
      let params = {
        phoneNumber: this.formData.phone,
      };
      getUserByPhoneNumber(params).then((res) => {
       if(res.data.success){
            this.formData.nickName = res.data.response.nickName;
       }else{
            this.$message.warning(res.data.message)
       }
      });
    },
    // 表格选中行
    handleCurrentChange(val) {
      console.log('val',val)
      this.currentRow = val;
    },
    // 每页条数改变
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getList();
    },
    // 当前页改变
    handleCurrentPageChange(val) {
      this.pageInfo.pageNum = val;
      this.getList();
    },
    // 查询数据
    getListData() {
      this.getList();
    },
    // 获取列表数据 - 主接口
    getList() {
      const params = {
        ...this.queryForm,
        pageIndex: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
      };
      // 调用大V列表接口
      getUserDvPageList(params)
        .then((res) => {
          if (res.data.success) {
            this.tableList = res.data.response.data || [];
            this.pageInfo.total = res.data.response.dataCount;
          } else {
            this.$message.error(res.data.message || "加载失败");
          }
        })
        .catch(() => {
          this.$message.error("列表数据加载失败，请重试");
        });
    },
    // 工具栏方法调用
    callFunction(item) {
      this[item.func] && this[item.func]();
    },
    // 新增
    handleAdd() {
      this.dialogTitle = "新增大V合作配置";
      this.resetForm();
      this.dialogVisible = true;
    },
    // 编辑 - 修复原代码bug
    handleEdit() {
      if (!this.currentRow) {
        this.$message.error("请选择要修改的数据！");
        return;
      }
      this.dialogTitle = "修改大V合作配置";
      const startDate = this.currentRow.startTime
        .replace(/年|月/g, "-")
        .replace("日", "");
      const endDate = this.currentRow.endTime
        .replace(/年|月/g, "-")
        .replace("日", "");
      this.formData = {
        id: this.currentRow.id,
        starName: this.currentRow.name,
        nickName: this.currentRow.nickName,
        phone: this.currentRow.phoneNumber,
        cooperateTime: [startDate, endDate],
      };

      this.dialogVisible = true;
    },
    // 记录按钮 - 截图里的记录操作
    handleRecord(row) {
      if (!row) {
        this.$message.error("请选择要查看记录的数据！");
        return;
      }
      this.$msgbox({
        title: "操作记录",
        message: `查看【${row.starName}】的操作记录`,
        showConfirmButton: false,
        closeOnClickModal: true,
      });
      // 此处可跳转记录页面/打开记录弹窗
    },
    // 删除
    handleDel() {
      if (!this.currentRow) {
        this.$message.error("请选择要删除的数据！");
        return;
      }
      this.$confirm("此操作将删除该大V合作配置, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteVipInfo({ id: this.currentRow.id })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("删除成功");
                this.getList();
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(() => {
              this.$message.error("删除接口请求失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    // 重置表单
    resetForm() {
      this.formData = {
        id: undefined,
        starName: undefined,
        nickName: undefined,
        phone: undefined,
        wechat: undefined,
        cooperateTime: undefined,
        isEnable: undefined,
        createTime: undefined,
        updateTime: undefined,
        createUserName: undefined,
        updateUserName: undefined,
      };
      this.$nextTick(() => {
        if (this.formRef) {
          this.formRef.resetFields();
        }
      });
    },
    // 保存（新增+编辑）
    handleSave() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;
        if (!this.formData.starName) {
          this.$message.error("大V姓名不存在，无法保存！");
          return;
        }

        let params = {
          ...this.formData,
          name: this.formData.starName,
          phoneNumber: this.formData.phone,
          startTime: this.formData.cooperateTime
            ? this.formData.cooperateTime[0]
            : undefined,
          endTime: this.formData.cooperateTime
            ? this.formData.cooperateTime[1]
            : undefined,
        };
        // 编辑保存
        if (params.id) {
          updateUserDv(params).then((res) => {
            if (res.data.success) {
              this.$message.success("修改成功");
              this.getList();
              this.dialogVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        } else {
          // 新增保存
          addUserDv(params).then((res) => {
            if (res.data.success) {
              this.$message.success("新增成功");
              this.getList();
              this.dialogVisible = false;
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  },
  mounted() {
    useEnterSearch(() => {
      this.getListData();
    });
    // 权限按钮
    const routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    // 初始化加载列表
    this.getList();
  },
};
</script>

<style scoped>
.commission-manager {
  padding: 20px;
  box-sizing: border-box;
}

/* 操作按钮红色匹配截图 */
::v-deep .el-button--text {
  color: #f56c6c !important;
  padding: 0 5px;
}
</style>